import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Kanban, Users, BarChart3, Upload, XCircle, LogOut, ShieldCheck, X } from 'lucide-react';
import { useAuth } from '@/lib/auth';

const LOGO_URL = "https://customer-assets-rejwkqb3.emergentagent.net/job_sales-analytics-base/artifacts/bju11je1_Final%20Logo-01.webp";

const baseNav = [
    { to: '/', label: 'Dashboard', icon: LayoutDashboard, testId: 'nav-dashboard' },
    { to: '/pipeline', label: 'Pipeline', icon: Kanban, testId: 'nav-pipeline' },
    { to: '/leads', label: 'Leads', icon: Users, testId: 'nav-leads' },
    { to: '/negative-leads', label: 'Negative Leads', icon: XCircle, testId: 'nav-negative' },
    { to: '/analytics', label: 'Analytics', icon: BarChart3, testId: 'nav-analytics' },
    { to: '/import', label: 'Import / Export', icon: Upload, testId: 'nav-import' },
];
const adminNav = [
    { to: '/admin/users', label: 'User Management', icon: ShieldCheck, testId: 'nav-admin-users' },
];

export default function Sidebar({ mobileOpen = false, onClose = () => { } }) {
    const { user, logout } = useAuth();
    const isAdmin = user?.role === 'admin';
    return (
        <aside
            className={`w-64 shrink-0 bg-[#043e52] text-white flex flex-col
                fixed md:sticky md:top-0 inset-y-0 left-0 z-40 md:z-auto
                h-screen md:h-screen overflow-y-auto
                transform transition-transform duration-200 ease-out
                ${mobileOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0`}
            data-testid="sidebar"
        >
            <div className="px-5 py-6 border-b border-white/10 relative">
                <img
                    src={LOGO_URL}
                    alt="Ikas Corp"
                    data-testid="sidebar-logo"
                    className="w-full h-auto brightness-0 invert"
                />
                <div className="mt-4">
                    <div className="text-[10px] uppercase tracking-[0.2em] text-white/50">Sales CRM</div>
                </div>
                <button
                    onClick={onClose}
                    data-testid="sidebar-close"
                    aria-label="Close menu"
                    className="md:hidden absolute top-4 right-4 p-2 rounded-md text-white/60 hover:text-white hover:bg-white/10"
                >
                    <X className="w-5 h-5" />
                </button>
            </div>
            <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
                {baseNav.map(n => (
                    <NavLink
                        key={n.to}
                        to={n.to}
                        end={n.to === '/'}
                        data-testid={n.testId}
                        className={({ isActive }) =>
                            `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors duration-200 ${isActive
                                ? 'bg-[#189290] text-white shadow-sm'
                                : 'text-white/70 hover:text-white hover:bg-white/10'}`
                        }
                    >
                        <n.icon className="w-4 h-4" />
                        {n.label}
                    </NavLink>
                ))}

                {isAdmin && (
                    <>
                        <div className="text-[10px] uppercase tracking-[0.2em] text-white/40 px-3 pt-4 pb-2">Admin</div>
                        {adminNav.map(n => (
                            <NavLink
                                key={n.to}
                                to={n.to}
                                data-testid={n.testId}
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors duration-200 ${isActive
                                        ? 'bg-[#dd683d] text-white shadow-sm'
                                        : 'text-white/70 hover:text-white hover:bg-white/10'}`
                                }
                            >
                                <n.icon className="w-4 h-4" />
                                {n.label}
                            </NavLink>
                        ))}
                    </>
                )}
            </nav>
            <div className="px-3 py-3 border-t border-white/10">
                {user && (
                    <div className="px-2 py-2 mb-2">
                        <div className="text-[10px] uppercase tracking-[0.2em] text-white/50">
                            Signed in {isAdmin && <span className="ml-1 text-[#fab06c]">· Admin</span>}
                        </div>
                        <div className="text-xs text-white truncate mt-1" data-testid="sidebar-user-email">{user.email}</div>
                    </div>
                )}
                <button
                    onClick={logout}
                    data-testid="btn-logout"
                    className="w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm text-white/70 hover:text-white hover:bg-white/10 transition-colors"
                >
                    <LogOut className="w-4 h-4" />
                    Sign out
                </button>
                <div className="mt-3 px-2">
                    <div className="text-[10px] uppercase tracking-[0.2em] text-white/40">Pipeline OS</div>
                    <div className="text-xs text-white/60 mt-1">Bengaluru · FY 2026</div>
                </div>
            </div>
        </aside>
    );
}
